import { render } from "./Herinneringsjuwelen.vue?vue&type=template&id=145e484a"
import script from "./Herinneringsjuwelen.vue?vue&type=script&lang=js"
export * from "./Herinneringsjuwelen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__